import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom'
import classnames from 'classnames'

export default class BackToTop extends React.Component {

  componentDidMount () {
    this.backToTop = ReactDOM.findDOMNode(this.refs.backToTop);
    this.backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  componentWillUnmount() {
    this.backToTop.removeEventListener('click', window.scrollTo);
  }

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classnames('c-button -secondary -full -top-icon', classes)}
        ref="backToTop"
      >
        TOPへ
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BackToTop.js